import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './Components/App';
import { HelmetProvider } from 'react-helmet-async';
import { Provider } from 'react-redux';
import store from './Redux/Store';

const rootElement = document.getElementById("root")

if (rootElement.hasChildNodes()) {
  ReactDOM.hydrate(
    <HelmetProvider>
      <Provider store={store}>
        <App />
      </Provider>
    </HelmetProvider>, rootElement
  )
}else{
  ReactDOM.render(
    <HelmetProvider>
      <Provider store={store}>
        <App />
      </Provider>
    </HelmetProvider>, rootElement
  )
}

